// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import cn from 'classnames';
import styles from './hamburger.module.less';

interface i_close_btn_props {
    on_toggle: ()=>void;
    is_open?: boolean;
    cls?: string;
}

export const Hamburger: React.FC<i_close_btn_props> = props=>{
    const {on_toggle, is_open, cls} = props;
    const root_cls = cn(styles.hamburger, is_open && styles.open, cls);
    return <a href="#" className={root_cls}
      onClick={ev=>{
        ev.preventDefault();
        on_toggle();
      }}>
      <span className={styles.toggle}><i/><i/><i/></span>
    </a>;
};
